import { Field } from "@sitecore-jss/sitecore-jss-react";
import React from "react";

import DateInput from "../../../components/InputFields/DateInput";
import { V26, V48, V58 } from "../../../components/InputFields/sanitizer/inputSanitizers";
import TextInput from "../../../components/InputFields/TextInput";
import { V5, V6, V10 } from "../../../components/InputFields/validator/validators";
import { PersonSearchData } from "../searchDupDlpPolicy/SearchDupDlpPolicy.state";
import styles from "./SearchByPersonFields.module.scss";

interface Props {
  fields: Record<string, Field<string>>;
  handleUpdatePerson: (data: Partial<PersonSearchData>) => void;
  values: Partial<PersonSearchData>;
}

export const SearchByPersonFields = ({ fields, handleUpdatePerson, values }: Props) => {
  const onChangeInserts = (inserts: string) => {
    handleUpdatePerson({ inserts });
  };

  const onChangeLastName = (lastName: string) => {
    handleUpdatePerson({ lastName });
  };

  const onChangeDateOfBirth = (dateOfBirth: string) => {
    handleUpdatePerson({ dateOfBirth });
  };

  return (
    <div className={styles.searchByPersonFields__wrapper}>
      <TextInput
        fieldData={fields}
        name="Inserts"
        fieldName="Inserts"
        sanitize={[V48]}
        validators={[V10(10)]}
        propertyName="Inserts"
        onBlur={onChangeInserts}
        widthClassName="short"
        excludeRow={true}
        inputValue={values.inserts}
      />
      <TextInput
        fieldData={fields}
        name="LastName"
        fieldName="LastName"
        sanitize={[V26, V48, V58]}
        validators={[V5, V10(35)]}
        propertyName="LastName"
        onBlur={onChangeLastName}
        widthClassName="medium"
        excludeRow={true}
        inputValue={values.lastName}
        required
      />
      <DateInput
        fieldData={fields}
        name="DateOfBirth"
        fieldName="DateOfBirth"
        validators={[V5, V6]}
        propertyName="DateOfBirth"
        onChange={onChangeDateOfBirth}
        inputValue={values.dateOfBirth}
        required
      />
    </div>
  );
};
